export function objectWithNull<T extends object>(obj: T): T | Record<string, unknown> {
  if (!obj) return {};
  let formatted = {};
  Object.keys(obj).forEach(k => {
    const key = k as keyof T;
    formatted = { ...formatted, [k]: obj[key] ? obj[key]: null };
  });
  return formatted as T;
}
